import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useContext } from 'react';
import { CookiesProvider } from 'react-cookie';
import { ErrorBoundary } from 'react-error-boundary';
import { FirebaseAppProvider, FirebaseAuthProvider } from 'libs.firebase_react';
import { FlagContext, FeatureFlagsProvider } from 'libs.flags.react';
import { JobsProvider } from 'libs.jobs.react';
import { I18nContextProvider, DialogProvider, ToastNotificationProvider } from 'libs.nucleus';
import { AppBannerProvider } from 'libs.react';
import { AuthProvider, ApiClientProvider, StepUpProvider, AuthContext, ProductTemplatesProvider, } from 'libs.react_internal';
import { ErrorPage, Router } from './components';
import { firebaseEnvConfig } from './constants/firebase_app.config';
import { shouldRetryQuery } from './helpers/react_query_retry';
import { useMessageProviderForDetectedLocale } from './hooks';
import { flagManager } from './utils';
const SUBDOMAIN_REGEX = /^[^.]+\./g;
const cookiesSetOptions = {
    domain: window.location.hostname.replace(SUBDOMAIN_REGEX, '.'),
    path: '/',
};
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: shouldRetryQuery,
        },
    },
});
const FirebaseAuthWrapper = ({ children }) => {
    const { user, entityId } = useContext(AuthContext);
    return (_jsx(FirebaseAuthProvider, { isLoggedIn: !!user, entityId: entityId, children: children }));
};
export const App = () => {
    const { detectedLocale, messageProvider } = useMessageProviderForDetectedLocale();
    return (_jsx(ErrorBoundary, { FallbackComponent: ErrorPage, children: _jsx(FlagContext.Provider, { value: flagManager, children: _jsx(CookiesProvider, { defaultSetOptions: cookiesSetOptions, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(FirebaseAppProvider, { firebaseConfig: firebaseEnvConfig, children: _jsx(I18nContextProvider, { locale: detectedLocale, messageProvider: messageProvider, children: _jsx(ToastNotificationProvider, { position: 'top-end', showClearAllButton: true, children: _jsx(DialogProvider, { children: _jsx(AppBannerProvider, { children: _jsx(ApiClientProvider, { children: _jsx(StepUpProvider, { children: _jsx(AuthProvider, { children: _jsx(FeatureFlagsProvider, { children: _jsx(ProductTemplatesProvider, { children: _jsx(FirebaseAuthWrapper, { children: _jsx(JobsProvider, { children: _jsx(Router, {}) }) }) }) }) }) }) }) }) }) }) }) }) }) }) }) }));
};
